export enum DeviceStatus {
	Offline = 'OFFLINE',
	Discovered = 'DISCOVERED',
	Online = 'ONLINE',
	Error = 'ERROR'
}
